import Base from '@studiometa/js-toolkit';
import { isDev } from './config';

/**
 * Main App class.
 */
class App extends Base {
  /**
   * App config.
   * @return {Object}
   */
  get config() {
    return {
      log: isDev(),
      name: 'App',
      components: {},
    };
  }

  /**""
   * Log a nice message when app is ready.
   *
   * @return {void}
   */
  mounted() {
    this.$log('mounted 🎉');
    // eslint-disable-next-line dot-notation
    window['console'].log(
      '%c Made with ❤ by Jérôme Wohlschlegel %c https://www.w-jerome.fr',
      'display: inline-block; background-color: #6d6ab1; color: #ffffff; font-weight: 500; margin-top: 8px; margin-bottom: 8px; padding: 8px; text-decoration: none !important; border: 2px solid #6d6ab1;',
      'display: inline-block; background-color: #ffff; color: #1f2126; font-weight: 500; margin-top: 8px; margin-bottom: 8px; padding: 8px; text-decoration: none !important; border: 2px solid #6d6ab1;'
    );
  }
}

const app = new App(document.documentElement);
window.app = app;
export default app;


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
